import React, { useContext, useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import { useParams } from 'react-router-dom';

import AuthContext from 'app/src/contexts/AuthContext';
import { Link } from 'app/src/utils/routing';
import {
  MainContainer,
  ContentContainer,
  PageTitle,
  LinkContainer,
  LinkSpace,
} from 'app/src/elements';
import Modal from 'app/src/elements/Modal';
import { currency } from 'app/src/utils/stringHelpers';
import { dateShort } from 'app/src/utils/timeFormatter';

import EditCreditMemo from './edit';

import { baseColumns } from '../Invoices';
import {
  INVOICES_WITH_COUNT as CUSTOMER_CREDITS_WITH_COUNT
} from '../Invoices/queries';
import SubNav from '../Invoices/SubNav';

const CreditMemos = () => {
  const { assetId } = useParams();
  const [showEditModal, setShowEditModal] = useState();
  const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const queryVariables = {
    assetId: assetId,
    filterColumns: [],
    filterNames: [],
    scopes: ['credit_memo'],
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const { accounts, role } = useContext(AuthContext);

  const columns = [
    ...baseColumns,
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: ({ entry }) => (
        <LinkContainer style={{ gap: 20 }}>
          <Pressable onPress={() => setShowEditModal(entry)}>
            <Text>Edit</Text>
          </Pressable>
        </LinkContainer>
      )
    },
  ];

  columns[1] = {
    ...columns[1],
    label: 'Reference',
  };

  columns[5] = {
    ...columns[5],
    label: 'Available Balance',
    value: ({ value }) => (parseFloat(value) ? parseFloat(value) * -1 : 0),
  };

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <View style={{padding: '20px'}}>
          <View style={{marginBottom: '20px'}}>
            <Filter.DateRange
              columnKey="bank_date"
              label="Date"
              filters={filters}
              setFilter={setFilter}
            />
          </View>
          <Text>Account:</Text>
          <select
            type={'select'}
            name="account_id"
            onChange={e => {
              setFilter('account_id', e.target.value)}
            }
            value={filters.account_id || ''}
          >
            <option key={`account-any`}>{'Any'}</option>
            {(accounts || []).map(account => (
              <option key={account.id} value={account.id}>
                {account.label}
              </option>
            ))}
          </select>
        </View>
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      {!assetId &&
        <SubNav refetch={refetch} screen="CreditMemos" />
      }

      <ContentContainer>
        <PageTitle>Customer Credits</PageTitle>

        <DataTable.Gql
          setRefetch={setRefetch}
          query={CUSTOMER_CREDITS_WITH_COUNT}
          queryName='txnsWithCount'
          queryVariables={queryVariables}
          columns={columns}
          pageLength={25}
          buttons={buttons}
          lengthMenu={ [10, 25, 50, 'All'] }
          setSettings={setSettings}
          dataUpdated={data => setFilterOptions(data?.txnsWithCount)}
          htmlTable
        />
      </ContentContainer>

      {showEditModal &&
        <Modal
          showModal
          setShowModal={setShowEditModal}
          modalType="Edit Customer Credit"
        >
          <EditCreditMemo
            txn={showEditModal}
            setShowModal={setShowEditModal}
            refetch={refetch}
          />
        </Modal>
      }
    </MainContainer>
  );
};

export default CreditMemos;
